import { SoftButtonLink } from 'components/Button';
import { useCountryParam } from 'utils/hooks';
import { useTheme } from 'styled-components';

export const BannerRow = ({ watchlistId, mixpanelMeta }) => {
    const theme = useTheme();
    const { mutateToWithCountryParam } = useCountryParam();
    return (
        <div css="width: 100%; padding: 0 20px; display: flex; justify-content: space-between;">
            <div css="display: flex; flex-direction: column;">
                <span css="font-weight: 500">
                    Did you add hashtags to your watchlist?
                </span>
                <span
                    css={`
                        font-size: 14px;
                        color: ${theme.gray_3};
                    `}
                >
                    Find trend hashtags and brand hashtags in the TikTok tab.
                    <SoftButtonLink
                        to={mutateToWithCountryParam(
                            `/watchlist/${watchlistId}/tiktok`,
                        )}
                        mixpanelMeta={mixpanelMeta}
                        mixpanelContext="Watchlist Banner Row"
                        css="border: none; margin-left: 4px;"
                    >
                        Switch to TikTok
                    </SoftButtonLink>
                </span>
            </div>
        </div>
    );
};
